import { useContext } from 'react'
import { LocaleContext } from '../../utils/context'
import { mapLocale } from '../../utils/mapping'

export const useUrl = () => {
    const { locale } = useContext(LocaleContext)
    return mapLocale[locale]
}